import axios from 'axios'
import { BACKEND_URL_STORE } from '@constants/server.constant'

export const listFacebookLivestreams = async () => {
  return await axios.get(`${BACKEND_URL_STORE}/facebook-livestream`)
}
